<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-23 
-->
<template>
  <div class="container">
    <div class="img-group">
      <img :src="static_img_url + 'pic/H5404.png?v=' + $store.state.imgVersion">
      <div class="desc-p" v-if="routerName == 'createShare'">
        <p>{{'该页面目前仅支持移动端浏览' | dealLanguage("This page is currently only supported for mobile browsing")}}</p>
        <p>{{'请在手机浏览器中查看' | dealLanguage("Please view it in your mobile browser")}}</p>
      </div>
      <div class="desc-p" v-else>
        <p>{{'找不到页面？' | dealLanguage("Can't find the page?")}}</p>
        <p>{{'别担心，' | dealLanguage("Don't worry, return to the ")}}<span @click="goBack">{{'返回首页' | dealLanguage('homepage')}}</span>{{'带您发现更多精彩。' | dealLanguage(' to discover more exciting things.')}}</p>
        <Button type="primary" @click="goBack">{{'返回首页' | dealLanguage('Home')}}</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  metaInfo() {
    return {
      title: this.activityDetail.name,
    }
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      activityDetail: (state) => state.activityDetail,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
    }),
    routerName() {
      return this.$route.name
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
<style lang='stylus' scoped>
.container
  display flex
  flex-direction column
  align-items center
  justify-content center
  position relative
  min-height calc(100vh - 64px)
  .img-group
    position relative
    img
      width 322px
      height 137px
    .desc-p
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      display flex
      align-items center
      justify-content center
      flex-direction column
      font-size 14px
      line-height 26px
      color #333333
      span
        color #C8161D
        &:hover
          color #E24147
      .ivu-btn-primary
        color #fff
        background-color #C8161D
        border-color #C8161D
        box-shadow none
        transition all 0.3s
        width 100px
        height 40px
        font-size 14px
        border-radius 10px
        margin-top 20px
        &:hover
          background-color #E24147
          border-color #E24147
</style>